/**
 * @file Generated by js-routes 2.4.1. Based on Rails 7.2.3 routes of Blog::Application.
 * @version f1002b48d1e36c3b5ecdd48c897033ddf10dd723c84961b1acf7f70d371641d4
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: true,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /classifieds/add_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comment_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/add_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comment_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/add_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comment_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/add_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comment_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admins/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /advertisement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advertisement_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"advertisement"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_dashboard_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/claims/received/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_dashboard_received_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[2,[6,"received"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"admin"]]);

/**
 * Generates rails route to
 * /admin/appearance_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_appearance_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"appearance_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_admins_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_amenities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_cities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_classified_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_classified_claims_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_contacts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_content_slots_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_event_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_home_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_llm_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_menus_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_newsletter_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_orders_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_page_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_partners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_plan_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_post_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_serper_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_testimonials_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/association_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_association_search_resources_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"association_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/attach-media(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_attach_media_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"attach-media"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/avo_api/:resource_name/search(.:format)
 * @param {any} resource_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_avo_api_path = /*#__PURE__*/ __route({"resource_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"avo_api"],[2,[7,"/"],[2,[3,"resource_name"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_avo_dashboards_redirect_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/avo_private/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_avo_private_status_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"avo_private"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_avo_resources_redirect_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/:resource_name/:field_id/distribution_chart(.:format)
 * @param {any} resource_name
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_distribution_chart_path = /*#__PURE__*/ __route({"resource_name":{"r":true},"field_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[3,"resource_name"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"distribution_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/summary/:resource_name(.:format)
 * @param {any} resource_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_distribution_chart_full_path = /*#__PURE__*/ __route({"resource_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"summary"],[2,[7,"/"],[2,[3,"resource_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/media-library/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_media_library_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"media-library"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_admin_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_amenity_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_city_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_classified_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_classified_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_contact_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_content_slot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_event_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_home_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_llm_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_menu_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_newsletter_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_order_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_page_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_partner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_plan_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_post_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_serper_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_tag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_testimonial_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_edit_resources_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/failed_to_load(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_failed_to_load_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"failed_to_load"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/media-library/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_media_library_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"media-library"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/media-library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_media_library_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"media-library"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_admin_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_amenity_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_city_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_classified_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_classified_category_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_classified_claim_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_comment_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_contact_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_content_slot_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_event_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_event_category_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_home_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_llm_call_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_menu_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_newsletter_subscription_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_order_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_page_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_partner_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_plan_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_plan_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_post_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_post_category_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_product_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_serper_call_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_subscription_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_tag_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_testimonial_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_new_resources_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_admin_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_amenity_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_city_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_classified_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_classified_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_contact_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_content_slot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_event_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_home_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_llm_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_menu_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_newsletter_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_order_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_page_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_partner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_plan_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_post_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_serper_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_tag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_testimonial_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_preview_resources_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_rails_active_storage_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admin_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/admins/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_admins_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenities_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_amenity_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_cities_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_city_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_categories_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classified_claims_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_classifieds_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_comments_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contact_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_contacts_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_content_slots_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_categories_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_event_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_events_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_home_banners_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_llm_calls_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menu_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_menus_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_newsletter_subscriptions_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_order_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_orders_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_page_banners_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_partners_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plan_types_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_plans_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_categories_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_post_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_posts_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_products_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_call_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_serper_calls_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_subscriptions_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_tags_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonial_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_testimonials_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_actions_handle_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users(/:id)/actions(/:action_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_actions_show_path = /*#__PURE__*/ __route({"id":{},"action_id":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[6,"actions"],[2,[1,[2,[7,"/"],[3,"action_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_associations_create_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_associations_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/:related_name(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_associations_index_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/:related_name/new(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_associations_new_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/:related_name/:related_id(.:format)
 * @param {any} id
 * @param {any} related_name
 * @param {any} related_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_associations_show_path = /*#__PURE__*/ __route({"id":{"r":true},"related_name":{"r":true},"related_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"related_name"],[2,[7,"/"],[2,[3,"related_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/:id/active_storage_attachments/:attachment_name/:attachment_id(.:format)
 * @param {any} id
 * @param {any} attachment_name
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_resources_users_attachments_destroy_path = /*#__PURE__*/ __route({"id":{"r":true},"attachment_name":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_storage_attachments"],[2,[7,"/"],[2,[3,"attachment_name"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"admin"]],[7,"/"]]);

/**
 * Generates rails route to
 * /admin/resources/admins/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_admins_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/amenities/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_amenities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"amenities"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/cities/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_cities_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_categories/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_classified_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_categories"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classified_claims/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_classified_claims_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classified_claims"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/classifieds/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/comments/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/contacts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_contacts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/content_slots/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_content_slots_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"content_slots"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/event_categories/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_event_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/events/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/home_banners/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_home_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"home_banners"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/llm_calls/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_llm_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"llm_calls"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/menus/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_menus_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/newsletter_subscriptions/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_newsletter_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/orders/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_orders_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/page_banners/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_page_banners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"page_banners"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/partners/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_partners_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plan_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_plan_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plan_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/plans/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/post_categories/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_post_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"post_categories"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/posts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/products/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/serper_calls/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_serper_calls_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"serper_calls"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/subscriptions/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/tags/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/testimonials/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_testimonials_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"testimonials"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/resources/users/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avo_search_resources_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"resources"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admins/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_admin_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /checkout/prev_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_prev_step_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"prev_step"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_update_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /classifieds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /classifieds/:classified_id/claim(.:format)
 * @param {any} classified_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const classified_claim_path = /*#__PURE__*/ __route({"classified_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"classified_id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /classifieds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /classifieds/categoria/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const classifieds_category_path = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"categoria"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comments/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_create_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /create_checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_checkout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"create_checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/claims(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_claims_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"claims"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/claims/received/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_received_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[2,[6,"received"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/claims/received(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_received_claims_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[2,[6,"received"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admins/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admins/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admins/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /classifieds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dashboard_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dashboard_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/load-more(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_more_dashboard_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"load-more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products/load-more(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_more_dashboard_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"load-more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/events/load-more(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_more_user_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"load-more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admins/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admins/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admins/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admins"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /classifieds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_classified_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /classifieds/:classified_id/claim/new(.:format)
 * @param {any} classified_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_classified_claim_path = /*#__PURE__*/ __route({"classified_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"classified_id"],[2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dashboard_classified_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dashboard_product_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_event_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_plan_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_event_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletter_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletter_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletter_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"newsletter_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_update_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/classifieds/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_dashboard_classified_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/claims/received/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_dashboard_received_claim_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"claims"],[2,[7,"/"],[2,[6,"received"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/products/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_dashboard_product_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /classifieds/search_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_categories_classifieds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"classifieds"],[2,[7,"/"],[2,[6,"search_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:collection-sitemap(:page).xml(.:format)
 * @param {any} collection
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_path = /*#__PURE__*/ __route({"collection":{"r":true},"page":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[3,"collection"],[2,[6,"-sitemap"],[2,[1,[3,"page"]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap_index.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_index_path = /*#__PURE__*/ __route({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap_index"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_events/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_events"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/remove_asset/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_remove_asset_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"remove_asset"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

